import { SERVICE_STATE_PRICE } from "../../api/endpoints";
import { baseApi, listTags } from "./baseApi";

const multipart =
  typeof FormData !== "undefined"
    ? { headers: { "Content-Type": "multipart/form-data" } }
    : {};

export const serviceStatePriceApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getServiceStatePrice: build.query({
      query: (params = {}) => ({
        url: SERVICE_STATE_PRICE.LIST,
        method: "GET",
        params,
      }),
      providesTags: (result) => listTags("ServiceStatePrice", result),
    }),
    getServiceStatePriceById: build.query({
      query: (arg) => {
        const id = typeof arg === "object" && arg != null ? arg.id : arg;
        const params =
          typeof arg === "object" && arg != null ? arg.params : undefined;
        return { url: SERVICE_STATE_PRICE.BY_ID(id), method: "GET", params };
      },
      providesTags: (_r, _e, arg) => [
        {
          type: "ServiceStatePrice",
          id: typeof arg === "object" && arg != null ? arg.id : arg,
        },
      ],
    }),
    createServiceStatePrice: build.mutation({
      query: (payload) => {
        const isFormData =
          typeof FormData !== "undefined" && payload instanceof FormData;
        return {
          url: SERVICE_STATE_PRICE.CREATE,
          method: "POST",
          data: payload,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: [{ type: "ServiceStatePrice", id: "LIST" }],
    }),
    updateServiceStatePrice: build.mutation({
      query: ({ id, data: updateData, params, ...rest }) => {
        const payload = updateData ?? rest;
        const isFormData =
          typeof FormData !== "undefined" && payload instanceof FormData;
        return {
          url: SERVICE_STATE_PRICE.BY_ID(id),
          method: "PUT",
          data: payload,
          params,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: (_r, _e, { id }) => [
        { type: "ServiceStatePrice", id },
        { type: "ServiceStatePrice", id: "LIST" },
      ],
    }),
    deleteServiceStatePrice: build.mutation({
      query: (id) => ({ url: SERVICE_STATE_PRICE.BY_ID(id), method: "DELETE" }),
      invalidatesTags: (_r, _e, id) => [
        { type: "ServiceStatePrice", id },
        { type: "ServiceStatePrice", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetServiceStatePriceQuery,
  useLazyGetServiceStatePriceQuery,
  useGetServiceStatePriceByIdQuery,
  useLazyGetServiceStatePriceByIdQuery,
  useCreateServiceStatePriceMutation,
  useUpdateServiceStatePriceMutation,
  useDeleteServiceStatePriceMutation,
} = serviceStatePriceApi;
